<template>
  <v-card class="py-5" style="height: 100%; border-radius: 20px;">
    <v-card-title class="justify-center">Technical Skills</v-card-title>
    <v-card-text>
      <v-container fill-height>
        <v-row class="ma-0 pa-0 body-1 font-weight-medium">
          <v-col cols="12">
            <v-row class="ma-0 pa-0">
              <v-col cols="6" class="text-left">JavaScript</v-col>
              <v-col cols="6" class="text-right">{{ skills.js }}%</v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col cols="12" class="ma-0 pa-0">
                <v-progress-linear
                  color="rgba(112,123,255)"
                  rounded
                  height="6"
                  :value="skills.js"
                />
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row class="ma-0 pa-0">
              <v-col cols="6" class="text-left">InDesign</v-col>
              <v-col cols="6" class="text-right">{{ skills.indesign }}%</v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col cols="12" class="ma-0 pa-0">
                <v-progress-linear
                  color="rgba(112,123,255)"
                  rounded
                  height="6"
                  :value="skills.indesign"
                />
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row class="ma-0 pa-0">
              <v-col cols="6" class="text-left">HTML</v-col>
              <v-col cols="6" class="text-right">{{ skills.html }}%</v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col cols="12" class="ma-0 pa-0">
                <v-progress-linear
                  color="rgba(112,123,255)"
                  rounded
                  height="6"
                  :value="skills.html"
                />
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row class="ma-0 pa-0">
              <v-col cols="6" class="text-left">CSS</v-col>
              <v-col cols="6" class="text-right">{{ skills.css }}%</v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col cols="12" class="ma-0 pa-0">
                <v-progress-linear
                  color="rgba(112,123,255)"
                  rounded
                  height="6"
                  :value="skills.css"
                />
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row class="ma-0 pa-0">
              <v-col cols="6" class="text-left">C# / Unity</v-col>
              <v-col cols="6" class="text-right">{{ skills.cSharp }}%</v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col cols="12" class="ma-0 pa-0">
                <v-progress-linear
                  color="rgba(112,123,255)"
                  rounded
                  height="6"
                  :value="skills.cSharp"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data: () => {
    return {
      skills: {
        js: 90,
        indesign: 90,
        html: 80,
        css: 80,
        cSharp: 50
      }
    };
  }
};
</script>

<style></style>
